import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-doc-modal',
  templateUrl: './view-doc-modal.component.html',
  styleUrls: ['./view-doc-modal.component.css']
})
export class ViewDocModalComponent implements OnInit {

  @Input() samplePicture="";
  constructor() {
   }

  ngOnInit(): void {
  }

  // zoomIn(event:any){
  //   let element = document.getElementById('docImage1');
  //   if(element){
  //     let currenWidth = element.clientWidth;
  //     let currentHeight = element.clientHeight;
  //     // let currentTop = element.clientTop;
  //     // const clientY= event.clientY;
  //     // const clientX = event.clientX;
  //     // const top= (currentHeight/2 - clientY);
  //     // const left= (currenWidth/2 - clientX);
  //     // console.log('height, width',currentHeight,clientY,currenWidth,clientX )
  //     // console.log('top bottom',(clientY-currentHeight),clientY)
  //     if(currenWidth == 2500) return false;
  //     else{
  //       element.style.width = (currenWidth + 100) + "px";
  //       element.style.height = (currentHeight + 100) + "px";
  //       // if(clientY > ((currentHeight + currentTop)/2)){
  //       //   element.style.top = (clientY - currentHeight)+"px";
  //       // }
  //       // else{
  //       //   element.style.top = (clientY)+"px";
  //       // }
  //     } 
  //   }
  //   return;
  // }
  // zoomOut(event:any){
  //   let element = document.getElementById('docImage1');
  //   if(element){
  //     let currenWidth = element.clientWidth;
  //     let currentHeight = element.clientHeight;
  //     // console.log("x y ",event.clientX, event.clientY)
  //     // const clientY= event.clientY;
  //     // const clientX = event.clientX;
  //     // const top= (currentHeight - clientY);
  //     if(currentHeight == 500) return false;
  //     else{
  //       element.style.width = (currenWidth - 100) + "px";
  //       element.style.height = (currentHeight - 100) + "px";
  //       // element.style.top = (0)+"px";
  //     } 
  //   }
  //   return;
  // }

  imageZoom(imgID:any, resultID:any) {
    var img:any, lens:any, result:any, cx:any, cy:any;
    img = document.getElementById(imgID);
    result = document.getElementById(resultID);
    /*create lens:*/
    lens = document.createElement("DIV");
    lens.setAttribute("class", "img-zoom-lens");
    // lens.setAttribute("position", "absolute");
    lens.setAttribute("style", "position:absolute;border:1px solid #d4d4d4;width:40px;height:40px");
    // lens.setAttribute("width", "40px");
    // lens.setAttribute("height", "40px");
    /*insert lens:*/
    img.parentElement.insertBefore(lens, img);
    /*calculate the ratio between result DIV and lens:*/
    cx = result.offsetWidth / lens.offsetWidth;
    cy = result.offsetHeight / lens.offsetHeight;
    /*set background properties for the result DIV:*/
    result.style.backgroundImage = "url('" + img.src + "')";
    result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
    /*execute a function when someone moves the cursor over the image, or the lens:*/
    lens.addEventListener("mousemove", moveLens);
    img.addEventListener("mousemove", moveLens);
    /*and also for touch screens:*/
    lens.addEventListener("touchmove", moveLens);
    img.addEventListener("touchmove", moveLens);
    function moveLens(e:any) {
      var pos, x, y;
      /*prevent any other actions that may occur when moving over the image:*/
      e.preventDefault();
      /*get the cursor's x and y positions:*/
      pos = getCursorPos(e);
      /*calculate the position of the lens:*/
      x = pos.x - (lens.offsetWidth / 2);
      y = pos.y - (lens.offsetHeight / 2);
      /*prevent the lens from being positioned outside the image:*/
      if (x > img.width - lens.offsetWidth) { x = img.width - lens.offsetWidth; }
      if (x < 0) { x = 0; }
      if (y > img.height - lens.offsetHeight) { y = img.height - lens.offsetHeight; }
      if (y < 0) { y = 0; }
      /*set the position of the lens:*/
      lens.style.left = x + "px";
      lens.style.top = y + "px";
      /*display what the lens "sees":*/
      result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
    }
    function getCursorPos(e:any) {
      var a, x = 0, y = 0;
      e = e || window.event;
      /*get the x and y positions of the image:*/
      a = img.getBoundingClientRect();
      /*calculate the cursor's x and y coordinates, relative to the image:*/
      x = e.pageX - a.left;
      y = e.pageY - a.top;
      /*consider any page scrolling:*/
      x = x - window.pageXOffset;
      y = y - window.pageYOffset;
      return { x: x, y: y };
    }
  }
}
